import styled from 'styled-components';

import Button from '@components/Button/next';
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 100px;
`;

export const Label = styled.div`
  margin: 40px 0 20px;
  text-align: center;
`;

export const Message = styled.div`
  margin-bottom: 40px;
  line-height: 1.56;
  text-align: center;
`;
export const ContentInfo = styled.p`
  margin: 0;
  margin-top: 20px;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: 767px) {
    text-align: justify;
  }
  ${(p) => p.theme.mediaQueries.SMALL} {
    text-align: left;
  }
`;

export const ContentConfirmation = styled.p`
  margin: 0px 0 0;
  font-size: 16px;
  line-height: 1.3;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: 767px) {
    text-align: justify;
  }
  ${(p) => p.theme.mediaQueries.SMALL} {
    text-align: left;
  }
`;

export const Title = styled.h2`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const Description = styled.span`
  opacity: 0.75;
  font-size: 14px;
  color: ${({ theme }) => theme.palette.darkGrey};
`;

export const StyledButton = styled(Button)`
  width: 250px !important;
  height: 60px !important;
  font-size: 16px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: column;
    align-items: center;
    margin-top: 80px;

    & > button {
      margin-bottom: 20px;
    }
  }
`;

export const ButtonsWrapperMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px;

  & > button {
    margin-bottom: 20px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
  }
`;

export const Div = styled.div`
  display: flex;
  justify-content: center;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.PHONE})`} {
    flex-direction: column;
    margin-top: 80px;
    max-width: 300px;
    padding-left: 40px;
  }
`;
export const HesTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${(p) => p.theme.palette.darkGrey};
  margin: 0;
`;

export const HesContent = styled.p`
  margin: 0px 0 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: 767px) {
    text-align: justify;
  }
  ${(p) => p.theme.mediaQueries.SMALL} {
    text-align: left;
  }
`;
export const PromotionContent = styled.div`
  margin: 0;
  font-size: 16px;
  line-height: 1.56;
  color: ${(p) => p.theme.palette.darkGray};
  @media (max-width: 550px) {
    text-align: justify;
  }
  ${(p) => p.theme.mediaQueries.SMALL} {
    text-align: left;
  }
`;
